import RequestService from "@/configurations/AxiosConfig";

const endpoints = {
  companies: 'companies',
};

const CompaniesService = {
  getAllCompanies: () => RequestService.get(endpoints.companies),
  getCompanyById: (id: string | number) => RequestService.get(`${endpoints.companies}/${id}`),
  createCompany: (data: FormData) => RequestService.post(endpoints.companies, data),
  updateCompany: (id: string | number, data: FormData) => RequestService.patch(`${endpoints.companies}/${id}`, data),
  deleteCompany: (id: string | number) => RequestService.delete(`${endpoints.companies}/${id}`),
};

export default CompaniesService;
